import { Skeleton, SkeletonLines } from '@otter-ai/den-components';

export function TwoFactorAuthStateLoading() {
  return (
    <div className="flex flex-col gap-4 py-4">
      <SkeletonLines size="lg" className="w-1/3" />
      <SkeletonLines size="sm" count={3} className="w-1/2" />
      <div className="flex gap-2">
        <Skeleton className="max-w-[100px] w-full" />
        <Skeleton className="max-w-[100px] w-full" />
      </div>
    </div>
  );
}
